import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TravelAgencyTour } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { TourTabHeading } from '../tour-content';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/project-html-renderer';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const PRICE_INCLUDES_ATTRIBUTE_ID = 4;
const PRICE_EXCLUDES_ATTRIBUTE_ID = 5;
const ISLAND_TOUR_ID = 12;

export function DescriptionTab({ tour }: { tour: TravelAgencyTour }) {
  const { t } = useTranslations();
  const priceIncludes = tour.attributes.find(attr => attr.id === PRICE_INCLUDES_ATTRIBUTE_ID);
  const priceExcludes = tour.attributes.find(attr => attr.id === PRICE_EXCLUDES_ATTRIBUTE_ID);

  const template = `
    <a href="https://www.youtube.com/watch?v=Xy7PNRHIXjc" target="_blank">
      <img alt="island" className="w-full h-auto object-cover object-center" src="/images/island.jpg" />
    </a>
  `;

  return (
    <div className={cn('flex w-full flex-col items-start justify-start gap-6 lg:gap-8 xl:gap-16')}>
      <div className="flex w-full flex-col items-start justify-start gap-6 lg:gap-8">
        <TourTabHeading title={t('text3958')} />
        <HtmlRenderer
          html={
            tour.id === ISLAND_TOUR_ID ? `${tour.description}<br><br>${template}` : tour.description
          }
          variant="description"
          className="ea-tour__description-tab-content w-full text-left"
        />
      </div>
      <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">
        <div className="col-span-1 flex h-fit w-full flex-col items-start justify-start gap-2 rounded-[24px] bg-[#F6F6F6] p-6 sm:gap-4 lg:p-8">
          <h3 data-ea-visual-tag="h4" className="text-sm font-bold text-foreground sm:text-base">{t('text3964')}</h3>
          <ul className="flex w-full flex-col items-start justify-start gap-2">
            {priceIncludes?.values &&
              priceIncludes.values.map(item => (
                <li
                  key={item.name}
                  className="flex items-center justify-start gap-2 text-sm font-light text-foreground"
                >
                  <Image
                    src={'/images/check-green.svg'}
                    alt={item.name}
                    width={16}
                    height={16}
                    className="min-w-4"
                  />
                  {item.name}
                </li>
              ))}
          </ul>
        </div>
        <div className="col-span-1 flex h-fit w-full flex-col items-start justify-start gap-2 rounded-[24px] bg-[#F6F6F6] p-6 sm:gap-4 lg:p-8">
          <h3 data-ea-visual-tag="h4" className="text-sm font-bold text-foreground sm:text-base">{t('text3965')}</h3>
          <ul className="flex w-full flex-col items-start justify-start gap-2">
            {priceExcludes?.values &&
              priceExcludes.values.map(item => (
                <li
                  key={item.name}
                  className="flex items-center justify-start gap-2 text-sm font-light text-foreground"
                >
                  <Image
                    src={'/images/close.svg'}
                    alt={item.name}
                    width={16}
                    height={16}
                    className="min-w-4"
                  />
                  {item.name}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
